<template>
  <v-app>
    <NewsPopup />
    <v-app-bar v-if="!hideAppBar" app color="#139393" dark>
      <SiteLogo></SiteLogo>
      <v-spacer></v-spacer>
    </v-app-bar>
    <v-main>
      <router-view :key="$route.fullPath" />
    </v-main>
    <Footer v-if="!hideAppBar"></Footer>
  </v-app>
</template>

<script>
import SiteLogo from "@/components/SiteLogo";
import Footer from "@/components/Footer";
import NewsPopup from '@/components/NewsPopup';
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({
      account: (state) => state.account.data,
    }),
    hideAppBar() {
      return this.$route.query.hide_app_bar === 'true';
    }
  },
  components: {
    SiteLogo,
    Footer,
    NewsPopup,
  },
  data: () => ({
    showMainMenu: false,
    type: null,
    showAccountMenu: false,
    minimised: false,
    dialog: false,
    dialogAccount: false,
    notifications: false,
    sound: true,
    widgets: false,
    debugMode: false,
    menu: [
      {
        icon: "mdi-home",
        route: { name: "PageMainHome" },
      },
      {
        icon: "mdi-calendar-star",
        route: { name: "PageMainEvent" },
      },
      {
        icon: "mdi-cloud-question",
        route: { name: "PageMainDiscover" },
      },
      // {
      //   icon: "mdi-bullhorn",
      //   route: { name: "PageMainNews" },
      // },
      {
        type: "divider",
      },
      {
        icon: "mdi-earth",
        route: { name: "PageMainLogin" },
        isGuest: true,
      },
      {
        type: "divider",
      },
      {
        icon: "mdi-earth",
        route: { name: "PageMainLanguage" },
      },
      // {
      //   icon: "mdi-help",
      //   route: { name: "PageMainHelp" },
      // },
      // {
      //   type: "divider",
      // },
      // {
      //   icon: "mdi-currency-usd",
      //   route: { name: "PageMainSupportUs" },
      // },
    ],
  }),
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style scoped>
</style>